"use client";
import { jsx as t, jsxs as d } from "react/jsx-runtime";
import { Group as r, Paragraph as e, Heading as m } from "@ingeniorforeningen/figurine-core";
import { forwardRef as x } from "react";
import '../../../../assets/CardSpot.css';const h = "_root_1h9og_2", f = "_texts_1h9og_8", u = "_fill_1h9og_15", s = {
  root: h,
  texts: f,
  fill: u
}, a = x((i, n) => {
  const { header: l, subject: o, text: c, ...p } = i;
  return /* @__PURE__ */ t(r, { ...p, direction: "row", spacing: "xs", ref: n, p: "xs", className: s.root, children: /* @__PURE__ */ d(r, { className: s.texts, pt: "xl", direction: "column", children: [
    o && /* @__PURE__ */ t(e, { variant: "light", text: o, medium: !0, condensed: !0, transform: "uppercase" }),
    /* @__PURE__ */ t(m, { type: "h2", text: l, variant: "light" }),
    /* @__PURE__ */ t(e, { text: c, lineClamp: 8, variant: "light" })
  ] }) });
});
a.displayName = "CardSpot";
const S = a;
export {
  a as _CardSpot,
  S as default
};
